import { Post } from "services/apiService";
import {
  GET_APPROVAL_ORDER_REQUEST,
  GET_APPROVAL_ORDER_SUCCESS,
  GET_APPROVAL_ORDER_ERROR,
} from "./action-type";
import { BASE_URL } from "services/CONSTANTS";

export const approvalManualOrders = (params) => async (dispatch) => {
  // Extract API key, limit, offset, and reqBody from the params (payload)
  const { apiKey, limit, offset, reqBody } = params;
  const apiUrl = `${BASE_URL}orders/@fetchorders?apikey=${apiKey}&offset=${offset}&limit=${limit}`;

  // Dispatch the request action to indicate that the fetch process is starting
  dispatch({ type: GET_APPROVAL_ORDER_REQUEST });
  try {
    const response = await Post({
      url: apiUrl, // The constructed URL
      params: reqBody, // The request body (payload)
      config: {}, // Default configuration for axios (can be extended if needed)
    });
    if (response.status === 200) {
      dispatch({
        type: GET_APPROVAL_ORDER_SUCCESS,
        payload: response.data,
      });
    } else {
      // Failure - Dispatch error
      dispatch({
        type: GET_APPROVAL_ORDER_ERROR,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_APPROVAL_ORDER_ERROR,
      payload: error.response.data,
    });
  }
};
